import { Dialog, useDialogProps } from "../../../../legacy-components/dialog/Dialog";
import React, { useEffect, useState } from "react";
import { Box, Button } from "@material-ui/core";
import ApiService from "../services/ApiService";
import { Alert } from "@material-ui/lab";
import { resolveAPIErrorMessage } from "modus/components/error-message/ErrorMessage";
import { VersionDialog } from "./VersionDialog";
import AddIcon from "@material-ui/icons/Add";
import { FormattedMessage } from "react-intl";
import { useAsyncAction } from "modus/components/form/async-actions/AsyncAction";
import { get } from "http";




interface VersionCreatorProp {
  getVersions: () => void;
  apiId: string;
}


export const VersionCreator: React.FC<VersionCreatorProp> = React.memo(
  ({ getVersions, apiId }) => {
    const [version, setVersion] = useState("");
    const { open, toggle, setOpen } = useDialogProps();

  const { state,  subscribe }  = useAsyncAction(() =>
    ApiService.createNewVersion(apiId, version),
  );


  useEffect(() => {
    if (!getVersions || !state.loaded || !setOpen) {
      return;
    }
    if(!state.error){
      setOpen(false);
      getVersions();
    }
    
    if(state.error) {
       if(!open){
        getVersions();
       }
    }
  }, [ state.loaded, state.error, getVersions, open, setOpen]);

  return (
    <Box key={"version-creator"}>
          <Button
            startIcon={<AddIcon />}
            variant="contained"
            color="primary"
            size="large"
            style={{ padding: "10px 21px", borderRadius: 0 }}
            onClick={toggle}
          >
            <FormattedMessage defaultMessage="Add New Version"></FormattedMessage>
          </Button>
    
      <Dialog
        open={open}
        onClose={toggle}
        title=" Add New Version"
      >
        {state?.error && (
          <Alert severity="error">{resolveAPIErrorMessage(state.error)}</Alert>
        )}
        <VersionDialog
          version={version}
          setVersion={setVersion}
          onClose={toggle}
          handleSubmit={subscribe}
          isLoading={state.loading}
        />
      </Dialog>
    </Box>
  );
});

export default VersionCreator;
